module.exports = __webpack_public_path__ + "static/media/angular-universal.f2495989.png";


//////////////////
// WEBPACK FOOTER
// ./src/slides/06-alternatives/images/angular-universal.png
// module id = 973
// module chunks = 0